export default function PanelActionButton(props: { text?: string, title: string, icon: string, action: ()=>void }) {
    return (
        <a
            title={props.title}
            style={{ color: 'unset', marginLeft: '2px' }}
            onClick={props.action}>
            <i className={"dx-icon " + props.icon} style={{ fontSize: 'unset' }}>{props.text}</i>
        </a>
    );
}
